import m from "../../geodata/es2015/costaRicaHigh";
window.am4geodata_costaRicaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/costaRicaHigh.js
// module id = null
// module chunks = 